export const ExternalLinks = {
  mozGitHub: 'https://github.com/mapofzones',
  mozTg: 'https://t.me/+wS9nPMWm1l43OGI6',
  mozTwitter: 'https://twitter.com/mapofzones',
  moz: 'https://mapofzones.com',
  mozEmail: 'mailto:support@mapofzones.com',
  tfmDocs: 'https://docs.tfm.com/',
  listingForm:
    'https://docs.google.com/forms/d/e/1FAIpQLSdts9X9KOeQMjXnU-bBgdx1X2EJvJ4tkuc6N5IOMARz6-dJoQ/viewform?usp=pp_url',
};
